<template>
  <div class="WToast">
    <div class="leading" :class="computedClass"><Icon :icon="iconName" class="icon" /></div>
    <div class="content">
      <span class="small medium">{{ message }}</span>
    </div>
  </div>
</template>

<script lang="ts">
  import type { ToastType } from '@/types';
  import type { PropType } from 'vue';
  import { Icon } from '@iconify/vue';

  export default {
    name: 'WToast',

    components: {
      Icon,
    },

    props: {
      id: {
        type: String as PropType<string | number>,
      },
      type: {
        type: String as PropType<ToastType>,
        default: 'default',
      },
      message: { type: String as PropType<string | Error>, required: true },
    },

    computed: {
      iconName() {
        switch (this.type) {
          case 'success':
            return 'fa6-solid:check';
          case 'warning':
            return 'fa6-solid:circle-exclamation';
          case 'error':
            return 'fa6-solid:xmark';
          default:
            return 'fa6-solid:circle-exclamation';
        }
      },
      computedClass() {
        return {
          success: this.type === 'success',
          warning: this.type === 'warning',
          error: this.type === 'error',
          default: this.type === 'default',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  .WToast {
    display: grid;
    grid-template-columns: auto 1fr;

    .leading {
      padding: 0.625rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.5rem 0 0 0.5rem;

      background-color: $neutral-gray;

      .icon {
        color: $white;
      }
      &.success {
        background-color: $primary-2;
      }
      &.warning {
        background-color: $communication-dark-yellow;
      }
      &.error {
        background-color: $communication-danger;
      }
    }

    .content {
      flex: 1;
      padding: 0.625rem;
      background-color: $bg-dark;
      color: $neutral-black;

      border-radius: 0 0.5rem 0.5rem 0;
      &.success {
        background-color: $status-green-light;
      }
      &.warning {
        background-color: $communication-light-yellow;
      }
      &.error {
        background-color: $communication-danger-light;
      }
    }
  }
</style>
